/* DRAPE Motion — vanilla JS for scroll reveals, Ken Burns, polish.
 * Loaded with `defer`. Respects prefers-reduced-motion.
 * Pattern: IntersectionObserver adds `.is-revealed` class to elements with `.dvA-reveal`.
 */
(function () {
  'use strict';

  if (typeof window === 'undefined') return;

  var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReduced) return; // No-op for reduced motion users.

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    /* ── SCROLL REVEAL via IntersectionObserver ── */
    var reveals = document.querySelectorAll('.dvA-reveal');
    if (reveals.length && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            io.unobserve(entry.target);
          }
        });
      }, {
        threshold: 0,
        rootMargin: '0px 0px 0px 0px'
      });
      reveals.forEach(function (el) {
        // If element is already in viewport on page load, reveal immediately
        var rect = el.getBoundingClientRect();
        if (rect.top < window.innerHeight && rect.bottom > 0) {
          requestAnimationFrame(function () { el.classList.add('is-revealed'); });
        } else {
          io.observe(el);
        }
      });

      // Fallback: scroll event triggers reveal too (in case IO misses on some browsers/heights)
      var scrollCheck = function () {
        document.querySelectorAll('.dvA-reveal:not(.is-revealed)').forEach(function (el) {
          var r = el.getBoundingClientRect();
          if (r.top < window.innerHeight * 0.95 && r.bottom > 0) {
            el.classList.add('is-revealed');
          }
        });
      };
      var ticking = false;
      window.addEventListener('scroll', function () {
        if (!ticking) {
          requestAnimationFrame(function () { scrollCheck(); ticking = false; });
          ticking = true;
        }
      }, { passive: true });
      // Initial check after a beat
      setTimeout(scrollCheck, 200);
    } else {
      // Fallback: show all
      reveals.forEach(function (el) { el.classList.add('is-revealed'); });
    }

    /* ── COLLECTION CARDS — hover zoom handled purely in CSS via background-size ── */

    /* ── LINK UNDERLINE: ensure cta elements have ::after available
     * (handled by CSS, no JS needed)
     */

    /* ── MARQUEE: duplicate content for seamless loop ── */
    document.querySelectorAll('.dvA-marquee__track').forEach(function (track) {
      var items = track.innerHTML;
      track.innerHTML = items + items; // duplicate so the -50% translate loops seamlessly
    });

    /* ── BACKGROUND VIDEO AUTOPLAY ──
     * iOS Safari (and Chrome on mobile in low-power mode) blocks autoplay
     * for <video autoplay muted loop playsinline> that are NOT in viewport
     * at page load. Hero plays (above the fold) but spread/atelier sit
     * paused at t=0 with the native play button showing.
     * Fix: IntersectionObserver calls .play() when the video scrolls in.
     */
    var bgVideos = document.querySelectorAll('video[autoplay][muted][loop], video[autoplay][playsinline]');
    if (bgVideos.length && 'IntersectionObserver' in window) {
      var tryPlay = function (v) {
        // Ensure attributes survived hydration (Safari can drop muted on clone).
        v.muted = true;
        v.playsInline = true;
        var p = v.play();
        if (p && typeof p.catch === 'function') {
          p.catch(function () { /* swallow; user can resume via tap on poster */ });
        }
      };
      var vio = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && entry.target.paused) {
            tryPlay(entry.target);
          }
        });
      }, { threshold: 0.1 });
      bgVideos.forEach(function (v) {
        // Kick once on load if already visible, then observe for scroll-in.
        var r = v.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) tryPlay(v);
        vio.observe(v);
      });
    }
  });
})();
